export const STATUSES = {
  EMPTY: 'empty',
  PENDING: 'pending',
  FULFILLED: 'fulfilled',
};

export const isEmpty = (status) => status === STATUSES.EMPTY;
export const isPending = (status) => status === STATUSES.PENDING;
export const isFulfilled = (status) => status === STATUSES.FULFILLED;
